export default __webpack_public_path__ + "assets/images/14dd05e632b59365f17e00cccd30f573.png";